import { Injectable } from '@angular/core';
import { TreeEntity } from '../models/entity.model';

@Injectable({
  providedIn: 'root'
})
export class ProductTreeTraverseService {
  static findInTreeById(selector: TreeEntity, id: string): TreeEntity {
    if (selector === null || id === '' || id === null) {
      return null;
    }
    if (selector.Id === id) {
      return selector;
    }
    for (const child of selector.Children) {
      const candidate = ProductTreeTraverseService.findInTreeById(child, id);
      if (candidate !== null) {
        return candidate;
      }
    }
    return null;
  }

  static findParentHoodId(selector: TreeEntity) {
    if (!selector) {
      return null;
    }
    // TODO: when added other hood types, check all hood type keys (see findParentHoodName function)
    if (selector.EntityTypeKey === 'GastroFlowHood') {
      return selector.Id;
    } else if (selector.ParentId) {
      return ProductTreeTraverseService.findParentHoodId(selector.Parent);
    } else {
      return null;
    }
  }

  /**
   * Returns the parent structure of the selector entity up to the hood it belongs to. The result is ordered from bottom
   * to top and both the selector entity and the hood are included.
   * @param selector
   * @param hoodTypeKeys
   */
  static findParentGraphUpToHood(selector: TreeEntity, hoodTypeKeys: string[]) {
    if (selector === null) {
      return null;
    }

    const graph: TreeEntity[] = [selector];

    // A bunch of helpers :)
    const getLastItemInGraph = () => graph[graph.length - 1];
    const lastItemInGraphIsHood = () => hoodTypeKeys.includes(getLastItemInGraph().EntityTypeKey);
    const lastItemInGraphHasParent = () => !!getLastItemInGraph().Parent;

    // Keep adding the parent of the last element until the last element either is the hood OR there's no more parent
    // elements.
    while (!lastItemInGraphIsHood() && lastItemInGraphHasParent()) {
      graph.push(getLastItemInGraph().Parent);
    }

    return graph;
  }
}
